<template>
  <div class="wrapper">
    <p>根据国家有关部门规定，12月31日前，所有用户必须完成实名注册。</p>
    <ul>
      <li>
        <h3>1.游客模式</h3>
        <p>现有的游客模式用户，游玩时长上限为一小时，并且15天内，同一个ID不得进行重复体验。</p>
      </li>
      <li>
        <h3>2.未成年人</h3>
        <h4>2.1针对未成年人的游戏时间：</h4>
        <p>未成年人的游戏时间每日不得超过90分钟；法定节假日每日游戏时间不得超过3个小时；每日22点~第二日8点，未成年人无法体验游戏服务。</p>
        <h4>2.2针对未成年人的消费：</h4>
        <p> 8岁以下的用户不得收费；8~16岁的用户，单次充值金额不得超过50元，每周累计消费必须在50元以下，每月累计消费不得超过200元；16岁~18岁的用户，单次充值金额不得超过100元，每周累计消费需要在100元以下，每月累计消费不得超过400元。</p>
      </li>
      <li>
        <h3>3.未在规定时间内实名认证</h3>
        <p>未在12月31日前实名认证的用户的游戏时间和消费按照未成年人（8岁以下）用户进行限制。</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less">
.wrapper{
  padding: 20px;
  p{
    color: #000;
  }
  ul{
    margin: 10px;
    li{
      line-height: 30px;
      margin-bottom: 10px;
      h3,h4{
        font-weight: 900;
      }
    }
  }
}


</style>